// Why ms-events-management rejected an event, as its error body says (docs/stage-capacity-changes-decision.md there)
export interface EventSaveErrorBody {
    message?: string;
    code?: 'STAGE_BELOW_SALES' | 'STAGE_HAS_SALES' | 'SALES_UNAVAILABLE' | string;
    stageName?: string;
    // Tickets of the stage sold or being paid
    committed?: number;
}

export const parseEventSaveError = (error: unknown): EventSaveErrorBody => {
    try {
        const body = JSON.parse(error instanceof Error ? error.message : '');
        return body && typeof body === 'object' ? body : {};
    } catch {
        return {};
    }
};

// The organizer reads it in Spanish; codes without a translation fall back to the backend's message
export const describeEventSaveError = (body: EventSaveErrorBody): string => {
    switch (body.code) {
        case 'STAGE_BELOW_SALES':
            return `La etapa "${body.stageName}" ya tiene ${body.committed} boletas vendidas o en pago. `
                + `Su aforo menos las cortesías no puede quedar por debajo de ${body.committed}.`;
        case 'STAGE_HAS_SALES':
            return `La etapa "${body.stageName}" ya tiene boletas vendidas o en pago, así que no se puede eliminar. `
                + 'Desactívala para dejar de venderla.';
        case 'SALES_UNAVAILABLE':
            return 'No pudimos revisar las ventas de las etapas para aplicar este cambio. Intenta de nuevo en unos minutos.';
        default:
            return body.message ?? '';
    }
};
